<template>
  <modal id="qualifiedApplication">
    <template slot="header">
      <button type="button" class="close close-popup" data-dismiss="modal" aria-label="Close"><span
        aria-hidden="true">×</span></button>
      <h2 class="modal-title" style="text-align: center;">Certified Applicator Application</h2>
    </template>

    <div class="alert alert-danger color-error msgblock" v-if="formErrors.message !== null">
      {{ formErrors.message }}
    </div>
    <div class="alert alert-success msgblock" v-if="formSuccess">
      {{ formSuccess}}<br>
      {{ formSuccess2}}
    </div>

    <form enctype="multipart/form-data" id="qualifier-form">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">How many years experience do you have using {{ $root.domainName }}?</label>
            <input type="text"
                   v-model="form.questionnaire[0].answer" class="form-control">
          </div><!-- /form-group -->
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">What pretreatment process do you offer/use?<br>(Cleaning Process)</label>
            <input type="text"
                   v-model="form.questionnaire[1].answer" class="form-control">
          </div><!-- /form-group -->
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">How many years has your company been in business?</label>
            <input type="text"
                   v-model="form.questionnaire[2].answer" class="form-control">
          </div><!-- /form-group -->
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">What markets or industries do you serve?</label>
            <input type="text"
                   v-model="form.questionnaire[3].answer" class="form-control">
          </div><!-- /form-group -->
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">Do you have a storefront or showroom that is open to the public during set business
              hours?</label>
            <input type="text"
                   v-model="form.questionnaire[4].answer" class="form-control">
          </div><!-- /form-group -->
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">What other coatings do you apply if any?</label>
            <input type="text"
                   v-model="form.questionnaire[5].answer" class="form-control">
          </div><!-- /form-group -->
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">What type of coating systems are you currently using?</label>
            <input type="text"
                   v-model="form.questionnaire[6].answer" class="form-control">
          </div><!-- /form-group -->
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">Please list any coating or professional certifications your company maintains.</label>
            <input type="text"
                   v-model="form.questionnaire[7].answer" class="form-control">
          </div><!-- /form-group -->
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">How large is your application area?</label>
            <input type="text"
                   v-model="form.questionnaire[8].answer" class="form-control">
          </div><!-- /form-group -->
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">What size is your oven?</label>
            <input type="text"
                   v-model="form.questionnaire[9].answer" class="form-control">
          </div><!-- /form-group -->
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">Do you distribute or sell {{ $root.domainName }}, equipment or supplies?</label>
            <input type="text"
                   v-model="form.questionnaire[10].answer" class="form-control">
          </div><!-- /form-group -->
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">Do you have a website, Facebook page, or Youtube channel? if so, please list</label>
            <input type="text"
                   v-model="form.questionnaire[11].answer" class="form-control">
          </div><!-- /form-group -->
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label for="">Comment</label>
            <textarea id="projectNotes" class="form-control"
                      v-model="form.comment"></textarea>
          </div><!-- /form-group -->
        </div>
      </div>
      <div class="form-group text-center">
        <button
          v-on:click.prevent="submitForm"
          class="btn btn-orange"
          :disabled="errors.any() || processing"
        >
          Submit
        </button>
      </div>
    </form>
  </modal>
</template>

<script>

  export default {
    name: 'qualified-application',

    data() {
      return {
        form: {
          comment: '',
          questionnaire: [
            {
              question: 'How many years experience do you have with Cerakote?',
              answer: ''
            },
            {
              question: 'What pretreatment process do you offer/use?',
              answer: ''
            },
            {
              question: 'How many years has your company been in business?',
              answer: ''
            },
            {
              question: 'What markets or industries do you serve?',
              answer: ''
            },
            {
              question: 'Do you have a storefront or showroom that is open to the public during set business hours?',
              answer: ''
            },
            {
              question: 'What other coatings do you apply if any?',
              answer: ''
            },
            {
              question: 'What type of coating system are you currently using?',
              answer: ''
            },
            {
              question: 'Please list any coating or professional certifications your company maintains.',
              answer: ''
            },
            {
              question: 'How large is your application area?',
              answer: ''
            },
            {
              question: 'What size is your oven?',
              answer: ''
            },
            {
              question: 'Do you distribute or sell Cerakote, equipment or supplies?',
              answer: ''
            },
            {
              question: 'Do you have a website, Facebook page, or Youtube channel? if so, please list.',
              answer: ''
            }
          ]
        },
        loading: false,
        processing: false,
        formSuccess: null,
        formSuccess2: null,
        formErrors: {message: null}

      }
    },

    mounted() {
      let vm = this;

      $('#qualifiedApplication').on('hidden.bs.modal', function () {
        vm.reloadModal();
      });
    },

    methods: {
      reloadModal() {
        this.formErrors.message = null;
      },
      submitForm() {
        if (this.processing) return false;

        this.formErrors.message = null;
        this.processing = true;

        let missingInput = 0;

        for (const input of this.form.questionnaire) {
          if (input.answer === '') {
            missingInput++;
          }
        }

        if (missingInput > 0) {
          this.$set(this.formErrors, 'message', 'Please fill out all application fields');
          $('.color-error').css('display', 'block');
          $('#qualifiedApplication').animate({
            scrollTop: ($('.modal-content').first().offset().top)
          }, 500);
          $('.modal .btn-orange').removeAttr('disabled');
          this.processing = false;
          return false;
        }


        axios({url: `/api/proxify/domains/cerakote/qualification-request`, method: 'POST', data: this.form})
          .then(response => {
            this.formSuccess = 'Your Applicator Application has been Successfully Submitted';
            this.formSuccess2 = 'Please allow 1-4 business days for it to be processed';
            $('#qualifiedApplication').animate({
              scrollTop: ($('.modal-content').first().offset().top)
            }, 500);
            $('.modal .btn-orange').removeAttr('disabled');
            this.$emit('application-submitted', true);
            this.processing = false;
            this.$nextTick(() => {
              this.errors.clear();
            });
          })
          .catch(() => {
            $('.modal .btn-orange').removeAttr('disabled');
            this.processing = false;
          })
          .then(response => {
            // No matter if it was successful or error out stop the processing
            $('.modal .btn-orange').removeAttr('disabled');
            this.processing = false;
          })
      }
    }
  }
</script>
